<template>
  <div
    style="position: relative; width: 100%; overflow: hidden" :class="src ? 'background_image':'background_no_image'"
    
  >
    <img v-if="src"
      class="preview-window" style="position: absolute; top: 50%;
        left: 50%;
        width: auto;
        height: auto;
        min-width: 100%;
        min-height: 100%;
        max-width: inherit;
        transform: translate(-50%, -50%);"
      alt="backgroundImage"
      :src="src"
      
    />
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";

@Options({
  props: {
    src: {
      type: String,
    },
  },
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  readonly src?: string;
}
</script>

<style lang="scss" scoped>
.background_image {
  height: 26vh;
}
.background_no_image{
  height: 8vh;
}

@media (min-width: 992px) {
  .background_image {
    height: 23vh;
  }
}
</style>
